import React, {useEffect, useState, useCallback} from 'react';
import { makeStyles } from '@material-ui/core';
import { Grid, Paper, Box, AppBar, Tabs, Tab, useMediaQuery, Button } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import _ from 'lodash'
import EditIcon from '@material-ui/icons/Edit';
import { useTheme } from '@material-ui/core/styles';
// icons
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
//import DeleteIcon from '@material-ui/icons/Delete';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import ReportIcon from '@material-ui/icons/Report';
import PersonIcon from '@material-ui/icons/Person';
import TimerIcon from '@material-ui/icons/Timer';
import PhonelinkLockIcon from '@material-ui/icons/PhonelinkLock';
import SchoolIcon from '@material-ui/icons/School';
import ContactPhoneIcon from '@material-ui/icons/ContactPhone';
import { useAuth } from '../../../providers/AuthContext';
import PaperTitle from '../Orders/OrderPage/PaperTitle';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';
// tabs
import InformationTab from './Tabs/InformationTab'
import ContactsTab from './Tabs/ContactsTab'
import UserReportTable from './Tables/UserReportTable';
import TrainingTab from './Tabs/TrainingTab'
import UserTimesheetTable from './Tables/UserTimesheetTable';
//import UserWorkOrdersTable from './Tables/UserWorkOrdersTable';
import MobileAuthTab from './Tabs/MobileAuthTab';
import MedicalTab from './Tabs/MedicalTab';

const useStyles = makeStyles((theme) => ({
    tabBar: {
        width: '100%',
        maxWidth: '1000px',
        zIndex: '998'
    },
    content: {
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        maxWidth: '1000px',
        margin: 'auto',
    },
    paper: {
        borderRadius: '0px',
        margin: '0px',
        marginBottom:'20px',
        width: '100%',
        maxWidth: '1400px',
        //backgroundColor: 'rgb(252, 252, 249)',
        justifyContent: 'center',
        alignItems: 'center',
    },
    backButton: {
        marginTop: '20px',
        marginBottom: '20px',
    },
}));

const MyUserCard = (props) => {
    const classes = useStyles();
    const theme = useTheme();
    const smallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const darkMode = JSON.parse(window.localStorage.getItem('colorMode')) === 'dark' ? true : false;
    const { roles, userInfo } = useAuth();

    const [value, setValue] = React.useState(JSON.parse(sessionStorage.getItem('userMyTab')) || 0);
    const [edit, setEdit] = React.useState(false);
    const [deleteOpen, setDeleteOpen] = useState(false);

    let userCard = null;

    const TabPanel = useCallback((props) => {
        const { children, value, index, ...other } = props;
        return (
            <div
              role="tabpanel"
              hidden={value !== index}
              id={`simple-tabpanel-${index}`}
              aria-labelledby={`simple-tab-${index}`}
              {...other}
            >
              {value === index && (
                <Box style={{margin:'20px'}}>
                  {children}
                </Box>
              )}
            </div>
          );
    }, []);

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
        sessionStorage.setItem("userMyTab", JSON.stringify(newValue))
    };

    const handleEdit = () => {
        if (edit)
            props.cancelSave();
                                                         
        setEdit(!edit);
    }

    const handleDeleteOpen = () => {
        setDeleteOpen(true);
    }

    const handleDeleteClose = () => {
        setDeleteOpen(false);
    }

    if (!_.isUndefined(props.userData)) {
        userCard = (
            <Grid className={classes.content}>
                {/* delete modal */}
                <Paper>
                    <Dialog
                        open={deleteOpen}
                        onClose={handleDeleteClose}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">{"Delete User?"}</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                Are you sure you want to delete this user?
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleDeleteClose} variant="contained" color="secondary">
                                No
                            </Button>
                            <Button onClick={(event) => {props.handleDeleteUser(); handleDeleteClose()}} variant="contained" style={{ backgroundColor: 'red', color: 'white' }} autoFocus>
                                Yes
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Paper>

                <Grid container className={classes.backButton}>
                    <Grid item xs={6}>
                        <Button variant="contained" onClick={() => props.history.goBack()} startIcon={<ArrowBackIcon/>}>Back</Button>
                    </Grid>
                    <Grid item xs={6}>
                        <Grid container justifyContent='flex-end'>
                            <Button variant="contained" onClick={handleEdit} startIcon={<EditIcon  style={edit ? { color: 'green' } :{}} />}>Edit</Button>
                        </Grid>
                    </Grid>
                </Grid>
               
                <Paper className={classes.paper}>
                    <div className={classes.content}>
                        <AppBar className={classes.tabBar} position="static" elevation={0} >
                            <Tabs 
                                value={value} 
                                onChange={handleChange} 
                                variant={smallScreen ? "scrollable" : "scrollable"} 
                                scrollButtons={"on"} 
                                style={{margin:'0px'}}
                            >
                                <Tab value={0} label={<div><PersonIcon style={{verticalAlign: 'middle'}} /> Info </div>} {...a11yProps(0)} />
                                <Tab value={1} label={<div><ContactPhoneIcon style={{verticalAlign: 'middle'}} /> Emergency Contacts </div>}  {...a11yProps(1)} /> 
                                <Tab value={2} label={<div><LocalHospitalIcon style={{verticalAlign: 'middle'}} /> Medical </div>}  {...a11yProps(2)} /> 
                                <Tab value={3} label={<div><TimerIcon style={{verticalAlign: 'middle'}} /> Timesheets </div>} {...a11yProps(3)} />
                                {/* <Tab value={3} label={<div><TimerIcon style={{verticalAlign: 'middle'}} /> Work Orders </div>} {...a11yProps(3)} /> */}
                                <Tab value={4} label={<div><SchoolIcon style={{verticalAlign: 'middle'}} /> Training </div>} {...a11yProps(4)} />
                                <Tab value={5} label={<div><ReportIcon style={{verticalAlign: 'middle'}} /> Documents </div>} {...a11yProps(5)} />
                                <Tab value={6} label={<div><PhonelinkLockIcon style={{verticalAlign: 'middle'}} /> Mobile Auth </div>} {...a11yProps(6)} />
                                {/* <IconButton onClick={handleEdit} style={edit ? { color: 'black' } :{}} title="Edit My Info"><EditIcon /></IconButton> */}
                            </Tabs>
                        </AppBar>

                    </div>
                    <Grid container style={{margin:'0px', padding:'10px', backgroundColor:darkMode?'grey':'lightgrey'}}>
                        <PaperTitle title={props.userData.displayName ? props.userData.displayName : props.userData.firstName + ' ' + props.userData.lastName}/>  
                    </Grid>

                    <TabPanel value={value} index={0}>
                        <InformationTab
                        userData={props.userData} saveState={props.saveState} edit={edit}
                        cancelSave={props.cancelSave} confirmSave={props.confirmSave} 
                        updateUserData={props.updateUserData} saving={props.saving}
                        setUserData={props.setUserData} setSaveState={props.setSaveState}
                        permissions={roles} userInfo={userInfo} me={props.me}
                        roles={props.roles} rolesLoading={props.rolesLoading}
                        units={props.units} unitLoading={props.unitLoading}
                        updateUserAndSaveData={props.updateUserAndSaveData}
                        />
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                        <ContactsTab
                        userData={props.userData} saveState={props.saveState} edit={edit}
                        cancelSave={props.cancelSave} confirmSave={props.confirmSave} 
                        updateUserData={props.updateUserData} saving={props.saving}
                        setUserData={props.setUserData} setSaveState={props.setSaveState}
                        />
                    </TabPanel>
                    <TabPanel value={value} index={2}>
                        <MedicalTab
                        userData={props.userData} saveState={props.saveState} edit={edit}
                        cancelSave={props.cancelSave} confirmSave={props.confirmSave} 
                        updateUserData={props.updateUserData} saving={props.saving}
                        setUserData={props.setUserData} setSaveState={props.setSaveState}
                        />
                    </TabPanel>
                    <TabPanel value={value} index={3}>
                    <Grid container spacing={2}>
                        <Grid item sm={12} xs={12}>
                            <UserTimesheetTable userData={props.userData} saveState={props.saveState} roles={roles}/>
                        </Grid>
                    </Grid>    
                    </TabPanel>
                    {/* <TabPanel value={value} index={3}>
                    <Grid container spacing={2}>
                        <Grid item sm={12} xs={12}>
                            <UserWorkOrdersTable userData={props.userData} saveState={props.saveState}/>
                        </Grid>
                    </Grid>    
                    </TabPanel> */}
                    <TabPanel value={value} index={4}>
                        <TrainingTab
                        userData={props.userData} saveState={props.saveState} edit={edit}
                        cancelSave={props.cancelSave} confirmSave={props.confirmSave} 
                        updateUserData={props.updateUserData} saving={props.saving}
                        setUserData={props.setUserData} setSaveState={props.setSaveState}
                        roles={roles}
                        />
                    </TabPanel>
                    <TabPanel value={value} index={5}>
                        <Grid container spacing={2}>
                            <Grid item sm={12} xs={12}>
                                <UserReportTable userData={props.userData} roles={roles}/>
                            </Grid>
                        </Grid>    
                    </TabPanel>
                    <TabPanel value={value} index={6}>
                        <MobileAuthTab
                        userData={props.userData}
                        updateUserData={props.updateUserData}
                        setUserData={props.setUserData}
                        updateUserAndSaveData={props.updateUserAndSaveData}
                        />
                    </TabPanel>

                </Paper>
            </Grid>
        )
    }

    return (
        <div>
            {userCard}
        </div>
    )
}

export default withRouter(MyUserCard)